'use strict';
var setSpecies = require('../internals/set-species');

// Set[@@species] property
// https://tc39.es/ecma262/#sec-get-set-@@species
setSpecies('Set');
